// Import List.js
import List from 'list.js';

// Make List.js globally accessible
window.List = List;